import React, { useEffect, useState} from "react";
import styled from 'styled-components';

import { useNavigate } from "react-router-dom";
import { eventTracker } from "../../services/eventTracker";

import ronin_chain from '../../styles/assets/chain/ronin.png';
import matic_chain from '../../styles/assets/chain/matic.png';
import eth_chain from '../../styles/assets/chain/eth.png';
import send from '../../styles/assets/send_icon.svg';
import swap from '../../styles/assets/transfer_icon.svg';

import {chainMap} from '../../services/chainServices/chainService';
import TokenListThumbnailImageComponent from './TokenListThumbnailImageComponent';

const TokenAmount = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.1px;
    color: #FFFFFF;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 180px;
`;

const TokenAmountPrice = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #7A7F9E;
    margin-top: 0px;
`;

const getCurrencyAmountFromItem = (item: any, currency:any) => {
    // ${parseFloat(Number(item.exchange[0].value).toFixed(6))}
    switch(currency) {
        case 'USD':
            return `${getCurrencySymbol(currency)}${parseFloat(Number( (item.exchange && item.exchange[0]) ? item.exchange[0].value : 0).toFixed(2))}`;
        case 'INR':
            return `${getCurrencySymbol(currency)}${parseFloat(Number((item.exchange && item.exchange[1]) ? item.exchange[1].value : 0).toFixed(2))}`;
        case 'BRL':
            return `${getCurrencySymbol(currency)}${parseFloat(Number((item.exchange && item.exchange[1]) ? item.exchange[1].value : 0).toFixed(2))}`;
    }
}    

const getCurrencySymbol = (currency: string) => {
    switch(currency) {
        case 'USD':
            return '$';
        case 'EUR':
            return '€';
        case 'GBP':
            return '£';
        case 'JPY':
            return '¥';
        case 'CNY':
            return '¥';
        case 'KRW':
            return '₩';
        case 'INR':
            return '₹';
        case 'RUB':
            return '₽';
        case 'BRL':
            return 'R$';
        default:
            return '$';
    }
}

const ChainName = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #7A7F9E;
`;

const TokenListItemComponent = (props:any) => {
    const navigate: any = useNavigate();
    
    const handleImageClick = () => {
        if(props.type === 'nft' || props.type === 'sbt') {
            navigate(`/wallet-host/nft-details/`, {state: props.item});
            eventTracker('NFT_Details_click', props.item);
        }
    }

    const getTokenName = () => {
        if(props.type === 'nft') {
            if(props.item.token.name)
                return props.item.token.name.toUpperCase();
            return ''
        }
        else{
            if(props.item.symbol)
                return props.item.symbol.toUpperCase()
        }
    }
    
    const isToken = (item:any)=>{
        if(item.type === 'ETH' || item.type === 'ERC20'){
            return true;
        }
        return false;
    }

    const openRoninSwap = () => {
        const walletType = localStorage.getItem('gw-wallet-type');
        const walletInfo = JSON.parse(localStorage.getItem('gw-wallet-info') || '{}');
        const walletAddress = walletInfo.address;
    
        window.location.href = `https://glip.gg/wallet-host-ronin?walletType=${walletType}&walletAddress=${walletAddress}`;
    };

    
    return (
        <div style={{display: 'flex', width: '100%', justifyContent: 'flex-start', alignContent: 'center', alignItems: 'center', paddingLeft: 12}}>
          <TokenListThumbnailImageComponent
              item={props.item}
          />
          <div style={{
              display: 'flex',
              width: '100%',
              justifyContent: 'space-between',
              alignContent: 'center',
              borderBottom: '0.5px solid #1C1F33',
              padding: 12,
          }}>
            <div style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignContent: 'center',
            }}>
              <div onClick={() => {handleImageClick()}} style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignContent: 'center',
              }}>
                <TokenAmount>{parseFloat(Number(props.item.quantity).toFixed(2))} {<>{getTokenName()}</>}
                </TokenAmount>
                {(isToken(props.item)) && <TokenAmountPrice style={{marginLeft: 8}}>{getCurrencyAmountFromItem(
                        props.item, props.currency)}
                </TokenAmountPrice>}
              </div>
              <ChainName>{chainMap[props.item.chain]}</ChainName>
            </div>
            {props.type != 'sbt' && <div style={{display: 'flex', justifyContent: 'flex-end'}}>
              {(props.type != 'nft' && props.item.symbol != 'BTX (Lock)' ) &&( 
              <>
                <div onClick={() => {
                    // if (props.item.chain === 'ronin') {
                    //     openRoninSwap();
                    //     return;
                    // }
                    navigate(
              '/wallet-host/swap',
                        {state: props.item});
                    eventTracker(
              'swap_click_home', props.item);
                }} style={{borderRadius: 100, width: 32, height: 32, background: '#26283E', display: 'flex', justifyContent: 'center', alignContent: 'center'}}>
                  <img style={{width: 20}} src={swap} alt='swap icon' />
                </div>
              </>
              )}
              {(props.item.symbol != 'BTX (Lock)') && (
                  <div onClick={() => {
                      navigate('/wallet-host/transfer', {state: props.item});
                      eventTracker('swap_click_home', props.item)
                  }} style={{marginLeft: 12, borderRadius: 100, width: 32, height: 32, background: '#26283E', display: 'flex', justifyContent: 'center', alignContent: 'center'}}>
                    <img style={{width: 20}} src={send} alt='send icon' />
                  </div>
              )}
              
            </div>}
          </div>
        </div>
    );
}
export default TokenListItemComponent;
